import React, { useCallback, useMemo } from 'react';
import { useFieldValidation } from '../../contexts/field-validation-context';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import FieldDescription from '../field-description';
import { TextField as TPATextField } from 'wix-ui-tpa/cssVars';
import FieldLabel from '../field-label';
import classNames from 'classnames';
import { useStyleParams } from '../../contexts/style-params-context';
import { getIsBorderStyleNone, getTextInputTheme } from '../text-field/utils';
import { classes } from '../text-field/text-field.st.css';
import { useConfig } from '../../contexts/config-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import FieldError from '../field-error';
import { getInputId, getLabelId } from '../../services/field-attributes';
const UrlInput = _ref => {
  let {
    id,
    target,
    path,
    value,
    required,
    label,
    hideLabel,
    disabled,
    placeholder,
    onChange,
    description,
    error,
    customErrors,
    fieldType,
    FieldLayout
  } = _ref;
  const inputId = getInputId(id);
  const labelId = getLabelId(id);
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType);
  const {
    validateFields
  } = useFieldValidation();
  const {
    isMobile
  } = useConfig();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const styleParams = useStyleParams();
  const theme = useMemo(() => getTextInputTheme({
    styleParams,
    mobile: isMobile
  }), [styleParams, isMobile]);
  const isBorderStyleNone = useMemo(() => getIsBorderStyleNone({
    styleParams,
    mobile: isMobile
  }), [styleParams, isMobile]);
  const handleBlur = useCallback(() => {
    let updatedValue = '';
    if (value) {
      const urlWithoutProtocol = String(value).replace(/^https?:\/\//, '');
      updatedValue = "https://" + urlWithoutProtocol;
    }
    onChange(updatedValue);
    validateFields({
      path,
      value: updatedValue
    });
  }, [onChange, path, validateFields, value]);
  const handleUrlChange = useCallback(event => {
    const newValue = event.target.value;
    onChange(newValue);
    if (hasError) {
      validateFields({
        path,
        value: newValue
      });
    }
  }, [onChange, path, validateFields, hasError]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    target: target,
    fieldType: fieldType,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabel, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TPATextField, {
      id: inputId,
      type: "url",
      error: hasError,
      newErrorMessage: true,
      value: value ? String(value) : '',
      className: classNames(classes.textField, {
        [FIELD_ERROR_CLASS]: hasError,
        [classes.noBorder]: isBorderStyleNone,
        [classes.hover]: forcedHover
      }),
      onChange: handleUrlChange,
      required: required,
      disabled: disabled,
      placeholder: placeholder,
      onBlur: handleBlur,
      "aria-label": label,
      theme: theme
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldError, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage
    }), /*#__PURE__*/React.createElement(FieldDescription, {
      description: description
    }))
  });
};
export default UrlInput;
//# sourceMappingURL=url-input.js.map